module.exports = __webpack_public_path__ + "static/media/id-card.6e2bc40b.png";